import { createDateTimeSecondFormatter } from '../utils/formatter';

const usePrintManagerReactTableCols = (timezone = 'America/New_York') => {
  // Create timezone-aware formatter
  const dateTimeSecondTzFormat = createDateTimeSecondFormatter(timezone);
  
  const printManagerCols = [
    {
      accessorKey: 'delete_action',
      header: '',
      size: 1,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { excludeFromExport: true },
    },
    {
      accessorKey: 'username',
      header: 'Username',
      size: 1,
      filterFn: "contains"
    },
    {
      accessorKey: 'event_name',
      header: 'Job Name',
      size: 1,
      filterFn: "contains",
    },
    {
      accessorKey: 'reportName',
      header: 'Report',
      size: 1,
      filterFn: "contains"
    },
    {
      accessorKey: 'createdAt',
      header: 'Created',
      size: 1,
      Cell: ({ cell }) => dateTimeSecondTzFormat(cell.getValue()),
    },
    {
      accessorKey: 'completedAt',
      header: 'Completed',
      size: 1,
      Cell: ({ cell }) => dateTimeSecondTzFormat(cell.getValue()),

    },
    // {
    //   accessorKey: '',
    //   header: '',
    //   size: 1,
    //   filterFn: "contains"
    // },
    {
      accessorKey: 'params_link',
      header: 'Params',
      size: 1,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { excludeFromExport: true },

    },
    {
      accessorKey: 'link',
      header: 'Link',
      size: 1,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { excludeFromExport: true },
    }
  ]
  return printManagerCols;
};

export { usePrintManagerReactTableCols };
